<template>
  <div class="ReservationCapacityChangeAfterMain">
    <Btn class="xs" data-cy="capacityChangeAfterMain" @click="isOpen = true">
      Keisti
    </Btn>
    <ModalCont v-if="isOpen" @close="close">
      <FormValidation class="change-modal" @submit="updateCapacity">
        <h3>Keisti rezervacijos galingumą</h3>
        <p>Dabartinis galingumas: {{ reservation.capacity | kw }}</p>
        <p>
          Dabartinė metinė priežiūros suma:
          {{ reservation.maintenanceAnnualTotal | currency }}
        </p>

        <Row>
          <Column :md="12">
            <Field
              data-cy="capacityWanted"
              label="Norimas galingumas (kW)"
              :min="0.1"
              required
              step="0.1"
              type="number"
              :value.sync="capacityWanted" />
          </Column>
        </Row>

        <Row v-if="isChanged">
          <Column :md="12">
            <div class="calculated-total">
              <strong>
                Nauja metinė priežiūros suma:
                <span data-cy="calculatedMaintenanceTotal">
                  {{ calculatedMaintenanceTotal | currency }}
                </span>
              </strong>
            </div>
          </Column>
        </Row>

        <Notice class="danger amendment-note">
          Sutarties priedas turi būti sudaromas rankiniu būdu.
        </Notice>

        <Row>
          <Column :xs="6">
            <Btn class="secondary" type="button" @click="close">
              Atšaukti
            </Btn>
          </Column>
          <Column :xs="6">
            <Btn
              class="success"
              data-cy="saveCapacityChange"
              :disabled="!isChanged"
              :isLoading="isSaving"
              type="submit">
              Išsaugoti
            </Btn>
          </Column>
        </Row>
      </FormValidation>
    </ModalCont>
  </div>
</template>

<script>
import Notice from 'components/globals/Notice'
import { actions } from '@/views/utils'

export default {
  components: { Notice },
  props: {
    reservation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      isSaving: false,
      capacityWanted: this.reservation.capacity,
    }
  },
  computed: {
    isChanged() {
      return (
        this.capacityWanted && this.capacityWanted !== this.reservation.capacity
      )
    },
    calculatedMaintenanceTotal() {
      if (!this.capacityWanted) return 0
      return this.capacityWanted * this.reservation.maintenancePerKw
    },
  },
  methods: {
    close() {
      this.isOpen = false
      this.capacityWanted = this.reservation.capacity
    },
    async updateCapacity() {
      await this.$wrap(
        () =>
          this.PATCH_RESERVATION({
            id: this.reservation.id,
            capacity: this.capacityWanted,
            $skipAmendment: true,
          }),
        'isSaving',
        'Galingumas pakeistas sėkmingai',
      )

      this.close()
    },
    ...actions('PATCH_RESERVATION'),
  },
}
</script>

<style lang="scss">
.ReservationCapacityChangeAfterMain {
  display: inline-block;
  margin-left: 0.5rem;

  .change-modal {
    padding: 1.5rem;
  }

  .calculated-total {
    background: rgba($success, 0.1);
    border: 1px solid rgba($success, 0.5);
    border-radius: 4px;
    margin-bottom: 1rem;
    padding: 0.75rem;
    text-align: center;

    span {
      color: $text-color;
      font-size: $h4;
    }
  }

  .amendment-note {
    margin-bottom: 1rem;
  }
}
</style>
